import { alpha } from '@mui/material/styles';
import { activeModeType } from '@shared/store/ducks/customizer/customizer.type';
import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  root: {
    width: '418px',
    minHeight: '367px',
    padding: '30px',
    borderRadius: '12px',
    backgroundColor: theme.palette.background.default,
    boxShadow: `0px 10px 10px ${alpha(theme.palette.extendedGrey.darker, 0.1)}`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    boxSizing: 'border-box',
    border: `1px solid ${
      theme.palette.mode === activeModeType.dark
        ? theme.palette.extendedGrey.lighter
        : theme.palette.border.default
    }`,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginBottom: '16px',
  },
  logo: {},
  title: {
    fontSize: '21px',
    fontWeight: 700,
    lineHeight: '130%',
    color: theme.palette.text.primary,
  },
  description: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '140%',
    letterSpacing: '-0.02em',
    color: theme.palette.text.primary,
  },
  main: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '6px',
    width: '100%',
  },
  fieldLabel: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '140%',
    letterSpacing: '-0.01em',
    color: theme.palette.text.primary,
  },
  fieldInput: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      minHeight: '40px',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.background.default,
      '& fieldset': {
        borderColor: theme.palette.border.default,
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px 14px',
      fontSize: '14px',
      lineHeight: '140%',
      letterSpacing: '-0.02em',
      color: theme.palette.text.primary,
    },
    '& .MuiInputAdornment-root .MuiSvgIcon-root': {
      fontSize: '16px',
      color: theme.palette.text.primary,
    },
    '& .MuiFormHelperText-root': {
      marginLeft: 0,
      marginRight: 0,
      marginTop: '4px',
      minHeight: '16px',
      fontSize: '12px',
      lineHeight: '140%',
      letterSpacing: '-0.02em',
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: theme.palette.error.main,
    },
    '& .MuiOutlinedInput-root.Mui-error fieldset': {
      borderColor: alpha(theme.palette.error.main, 0.55),
    },
  },
  errorAlert: {
    marginTop: '4px',
    padding: '8px 12px',
    borderRadius: theme.shape.borderRadius,
    alignItems: 'flex-start',
    backgroundColor: theme.palette.status.danger.background,
    color: theme.palette.status.danger.foreground,
    border: `1px solid ${theme.palette.status.danger.border}`,
    '& .MuiAlert-icon': {
      marginRight: '8px',
      padding: 0,
      opacity: 1,
    },
    '& .MuiAlert-message': {
      padding: 0,
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '140%',
      letterSpacing: '-0.02em',
    },
  },
  errorIcon: {
    fontSize: '16px',
    color: theme.palette.error.main,
    marginTop: '1px',
  },
  forgotPasswordLink: {
    alignSelf: 'flex-end',
    marginTop: '-2px',
    color: theme.palette.primary.main,
    fontSize: '13px',
    lineHeight: '140%',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: '2px',
      borderRadius: '2px',
    },
  },
  ssoDivider: {
    margin: '2px 0',
    color: theme.palette.text.secondary,
    fontSize: '12px',
    lineHeight: '140%',
    letterSpacing: '-0.02em',
    '&::before, &::after': {
      borderColor: theme.palette.border.default,
    },
  },
  ssoButton: {
    width: '100%',
    height: '40px',
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '140%',
    letterSpacing: '-0.02em',
  },
  login_btn: {
    width: '100%',
    '& .MuiButton-root': {
      height: '40px',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.primary.main,
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '140%',
      letterSpacing: '-0.02em',
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
}));
